/* eslint-disable arrow-body-style */
export const required = (value) => { return value ? undefined : 'Required'; };

export const email = (value) => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined;
};



// WEBPACK FOOTER //
// ./src/utils/form-validators.js